export const EXTENDED_FIELD_ERROR_TYPE = '@ci/validations/EXTENDED_FIELD_ERROR_TYPE' as const;
